export class OutingDto {
    organizationId: string;
    name: String;
    startDate: Date;
    cost: number;
    courseId: string;
    createdBy: string;
    registrationCode: string;

    map(outingForm: any, outingIterationForm: any){
        this.name = outingForm.get('name').value;
        this.startDate = outingIterationForm.get('startDate').value;
        this.cost = outingIterationForm.get('cost').value;
        this.courseId = outingIterationForm.get('course').value?.id;
        this.registrationCode = outingIterationForm.get('registrationCode').value;
    }
}
